function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1795",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.707151,225.73641 c -1.635832,-2.25142 -4.288367,-3.71651 -7.284508,-3.71651 -2.99579,0 -5.648676,1.46509 -7.28486,3.71651 l 1.974496,3.42054 5.310364,9.19762 5.31001,-9.19762 1.974498,-3.42054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1797",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "M 39.422643,238.35457 H 32.15542 c 2.615142,8.19608 7.267223,19.49062 7.267223,19.49062 0,0 4.651726,-11.29454 7.266868,-19.49062 h -7.266868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1799",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.869515,229.98986 c -2.748527,-0.43569 -5.660707,0.40428 -7.779032,2.52271 -2.118466,2.11843 -2.958395,5.03061 -2.523349,7.77945 l 3.814833,1.02165 10.25839,2.7492 -2.748774,-10.25843 -1.022068,-3.81458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1801",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 25.640357,244.06287 -5.138279,5.13856 c 7.645082,3.94687 18.920565,8.64376 18.920565,8.64376 0,0 -4.696883,-11.27584 -8.64376,-18.92053 l -5.138526,5.13821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1803",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 7.3139748,250.56033 c -2.25171,1.63547 -3.71669,4.28872 -3.71669,7.28451 0,2.99578 1.46498,5.64903 3.71669,7.2845 l 3.4198632,-1.97414 9.198151,-5.31036 -9.197869,-5.31037 -3.4201452,-1.97414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1805",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.931989,257.84484 v 7.26722 c 8.196157,-2.6155 19.490654,-7.26687 19.490654,-7.26687 0,0 -11.294779,-4.65244 -19.490654,-7.26722 v 7.26687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1807",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 11.567134,275.398 c -0.435716,2.74884 0.40446,5.66067 2.522926,7.77875 2.118466,2.11843 5.030541,2.95875 7.779455,2.52342 l 1.021786,-3.81459 2.749056,-10.25878 -10.258813,2.74885 -3.81441,1.02235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1809",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 25.640357,271.6268 5.138526,5.13892 c 3.946877,-7.6454 8.64376,-18.92053 8.64376,-18.92053 0,0 -11.276329,4.69618 -18.920565,8.64341 l 5.138279,5.1382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1811",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.137783,289.95326 c 1.635477,2.25213 4.288366,3.71686 7.284508,3.71686 2.995787,0 5.648677,-1.46508 7.284508,-3.71686 l -1.974498,-3.41948 -5.31001,-9.19833 -5.310716,9.19798 -1.973792,3.41983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1813",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.422291,277.33545 7.26722,2.7e-4 c -2.615493,-8.19679 -7.266868,-19.49062 -7.266868,-19.49062 0,0 -4.652785,11.29418 -7.267574,19.49027 h 7.267222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1815",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.975454,285.70017 c 2.748843,0.43568 5.659966,-0.40428 7.77875,-2.52307 2.118431,-2.11808 2.958748,-5.03026 2.523418,-7.7791 l -3.814585,-1.022 -10.258778,-2.7492 2.748844,10.25914 1.022351,3.81423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1817",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.204259,271.6268 5.138913,-5.1382 c -7.645398,-3.94723 -18.920529,-8.64341 -18.920529,-8.64341 0,0 4.696176,11.27583 8.643056,18.92053 l 5.13856,-5.13892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1819",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 71.530712,265.12934 c 2.252133,-1.63547 3.716515,-4.28766 3.716515,-7.28415 0,-2.99579 -1.464733,-5.64903 -3.716515,-7.28486 l -3.419827,1.9745 -9.197975,5.31036 9.197975,5.31071 3.419827,1.97344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1821",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.91291,257.84519 v -7.26758 c -8.196792,2.6155 -19.490267,7.26758 -19.490267,7.26758 0,0 11.293826,4.65208 19.490267,7.26722 v -7.26722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1823",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.277622,240.29202 c 0.435682,-2.74884 -0.404283,-5.66031 -2.523066,-7.7791 -2.118429,-2.11843 -5.030259,-2.95875 -7.779102,-2.52306 l -1.021997,3.81458 -2.749198,10.25843 10.25913,-2.74885 3.814233,-1.022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1825",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.204259,244.06287 -5.13856,-5.13821 c -3.94688,7.6454 -8.643056,18.92053 -8.643056,18.92053 0,0 11.275483,-4.69689 18.920529,-8.64341 l -5.138913,-5.13891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1827",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.865335,225.39316 c -2.373135,-1.4545 -5.383988,-1.79246 -8.152482,-0.64629 -2.768212,1.14653 -4.65776,3.51508 -5.30793,6.22159 l 3.132984,2.40418 8.425603,6.46536 1.386417,-10.52971 0.515408,-3.91513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1829",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.96351,239.838 -6.713678,2.78095 c 5.552687,6.57189 14.172811,15.22624 14.172811,15.22624 0,0 -0.02434,-12.21493 -0.745067,-20.78814 L 31.96351,239.838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1831",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.545704,238.82764 c -2.7061932,0.64912 -5.0750612,2.5393 -6.2215882,5.30755 -1.146246,2.76789 -0.807791,5.77955 0.646324,8.15269 l 3.9154102,-0.51541 10.529605,-1.38642 -6.465076,-8.42574 -2.404675,-3.13267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1833",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.415455,250.38605 -2.781018,6.71407 c 8.573594,0.72073 20.788206,0.74507 20.788206,0.74507 0,0 -8.654698,-8.62048 -15.226311,-14.17285 l -2.780877,6.71371"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1835",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 6.9704398,263.4025 c -1.454538,2.37243 -1.79257,5.38374 -0.646324,8.15199 1.146527,2.76789 3.514971,4.65842 6.2215882,5.30789 l 2.403828,-3.13302 6.465923,-8.42574 -10.529605,-1.38607 -3.9154102,-0.51505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1837",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.415455,265.30362 2.780877,6.71442 c 6.571613,-5.55343 15.226311,-14.17285 15.226311,-14.17285 0,0 -12.215459,0.0236 -20.788206,0.74471 l 2.781018,6.71372"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1839",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.404923,284.72156 c 0.649041,2.70651 2.539295,5.07471 5.307506,6.22159 2.768212,1.14618 5.779771,0.80821 8.152554,-0.64629 l -0.515408,-3.91512 -1.386065,-10.52972 -8.425885,6.46536 -3.132702,2.40418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1841",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.96351,275.85202 6.714066,2.7813 c 0.720373,-8.57391 0.745067,-20.78813 0.745067,-20.78813 0,0 -8.620831,8.65434 -14.172811,15.22589 l 6.713678,2.78094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1843",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.979599,290.29686 c 2.372783,1.45486 5.383742,1.79282 8.152342,0.64629 2.767893,-1.14653 4.658078,-3.51508 5.307894,-6.22159 l -3.133019,-2.40347 -8.425747,-6.46607 -1.386416,10.52972 -0.515054,3.91512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1845",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.881069,275.85202 6.714422,-2.78059 c -5.55343,-6.57225 -14.172848,-15.22624 -14.172848,-15.22624 0,0 0.02328,12.21493 0.74436,20.78778 l 6.714066,-2.78095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1847",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 66.298664,276.86238 c 2.706865,-0.64911 5.075063,-2.53894 6.22159,-5.30754 1.146175,-2.76825 0.808215,-5.77991 -0.64629,-8.15234 l -3.914775,0.5154 -10.530062,1.38572 6.46571,8.42645 2.403827,3.13231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1849",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.429127,265.30362 2.7813,-6.71407 c -8.573559,-0.72037 -20.787784,-0.74436 -20.787784,-0.74436 0,0 8.653639,8.62012 15.225535,14.17285 l 2.780949,-6.71442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1851",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 71.874319,252.28788 c 1.454501,-2.37314 1.792816,-5.38409 0.646287,-8.15269 -1.146527,-2.76755 -3.515429,-4.65808 -6.221942,-5.30755 l -2.403827,3.13267 -6.465358,8.42574 10.52971,1.38678 3.91513,0.51505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1853",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.429479,250.38605 -2.781301,-6.71371 c -6.571896,5.55308 -15.225535,14.17285 -15.225535,14.17285 0,0 12.214576,-0.024 20.787429,-0.74472 l -2.780593,-6.71442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1855",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.439835,230.96846 c -0.649465,-2.70686 -2.538942,-5.07471 -5.307542,-6.22123 -2.768249,-1.14653 -5.779911,-0.80857 -8.152694,0.64593 l 0.515408,3.91513 1.386062,10.53006 8.426099,-6.46571 3.132667,-2.40418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1857",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.881069,239.83835 -6.714418,-2.78094 c -0.720373,8.57355 -0.744008,20.78778 -0.744008,20.78778 0,0 8.619773,-8.65399 14.172848,-15.22589 l -6.714422,-2.78095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1859",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.821428,238.45582 c -0.987777,-1.35961 -2.589387,-2.24402 -4.398785,-2.24402 -1.809399,0 -3.411009,0.88441 -4.399139,2.24402 l 1.192389,2.06551 3.20675,5.55413 3.20675,-5.55413 1.192035,-2.06551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1861",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.422643,246.07546 h -4.388556 c 1.579032,4.94948 4.388556,11.76973 4.388556,11.76973 0,0 2.809168,-6.82025 4.388201,-11.76973 h -4.388201"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1863",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.822659,241.02439 c -1.659572,-0.26317 -3.417816,0.24412 -4.697306,1.5233 -1.279243,1.27917 -1.786361,3.03776 -1.523577,4.69758 l 2.303392,0.61737 6.194742,1.65981 -1.65989,-6.19477 -0.617361,-2.30329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1865",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.09991,249.52245 -3.103103,3.10304 c 4.616872,2.38336 11.425836,5.2197 11.425836,5.2197 0,0 -2.836334,-6.80932 -5.219699,-11.42577 l -3.103034,3.10303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1867",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.033272,253.44605 c -1.359429,0.98778 -2.244125,2.58939 -2.244125,4.39879 0,1.80939 0.884696,3.41136 2.244125,4.39913 l 2.065267,-1.19238 5.554168,-3.20675 -5.553745,-3.2064 -2.06569,-1.19239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1869",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.652707,257.84484 v 4.38855 c 4.949685,-1.57939 11.769936,-4.3882 11.769936,-4.3882 0,0 -6.820251,-2.80952 -11.769936,-4.38856 v 4.38821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1871",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 22.601776,268.44475 c -0.263172,1.65982 0.243946,3.41771 1.523577,4.69724 1.279101,1.27952 3.037487,1.78681 4.697306,1.52329 l 0.617079,-2.30329 1.660172,-6.19442 -6.194742,1.65982 -2.303392,0.61736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1873",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.09991,266.16757 3.103034,3.10303 c 2.383365,-4.6168 5.219699,-11.42541 5.219699,-11.42541 0,0 -6.809668,2.83598 -11.425836,5.21935 l 3.103103,3.10303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1875",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.023504,277.23421 c 0.987778,1.3596 2.589389,2.24402 4.398787,2.24402 1.809395,0 3.41136,-0.88477 4.398785,-2.24402 l -1.192035,-2.06552 -3.20675,-5.55413 -3.20675,5.55413 -1.192037,2.06552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1877",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.422291,269.61456 4.388553,2.6e-4 C 42.231459,264.665 39.422643,257.8451 39.422643,257.8451 c 0,0 -2.809875,6.8199 -4.388908,11.76937 h 4.388556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1879",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.022203,274.66528 c 1.659821,0.26352 3.417713,-0.24342 4.697238,-1.52329 1.279526,-1.27953 1.786467,-3.03742 1.523294,-4.69724 l -2.303286,-0.61701 -6.194425,-1.66017 1.659819,6.19478 0.61736,2.30293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.745024,266.16757 3.102679,-3.10303 c -4.61645,-2.38337 -11.42506,-5.21935 -11.42506,-5.21935 0,0 2.835981,6.80931 5.219348,11.42541 l 3.103033,-3.10303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1883",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.811662,262.24397 c 1.359607,-0.98777 2.244019,-2.58903 2.244019,-4.39878 0,-1.8094 -0.884767,-3.41136 -2.244019,-4.39914 l -2.065515,1.19239 -5.554131,3.20675 5.554131,3.20675 2.065515,1.19203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1885",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 51.192016,257.84519 v -4.38891 c -4.949825,1.57939 -11.769373,4.38891 -11.769373,4.38891 0,0 6.8199,2.80952 11.769373,4.38855 v -4.38855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1887",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.242735,247.24527 c 0.263173,-1.65982 -0.243416,-3.41806 -1.523294,-4.69758 -1.279525,-1.27882 -3.037417,-1.78647 -4.697238,-1.5233 l -0.61736,2.30329 -1.659819,6.19477 6.194777,-1.65981 2.302934,-0.61737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1889",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.745024,249.52245 -3.103033,-3.10303 c -2.383367,4.61681 -5.219348,11.42577 -5.219348,11.42577 0,0 6.80861,-2.83634 11.42506,-5.2197 l -3.102679,-3.10304"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1891",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.066668,238.24838 c -1.432983,-0.87806 -3.251551,-1.08232 -4.92266,-0.39017 -1.671991,0.6925 -2.813297,2.12266 -3.205621,3.75708 l 1.891629,1.45168 5.088361,3.9042 0.83679,-6.35847 0.311501,-2.36432"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1893",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.918377,246.97117 -4.054475,1.67922 c 3.353152,3.9684 8.558741,9.1948 8.558741,9.1948 0,0 -0.01482,-7.37623 -0.450144,-12.55325 l -4.054122,1.67923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1895",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.192432,246.36086 c -1.634102,0.39229 -3.064228,1.53388 -3.756942,3.20534 -0.692221,1.67111 -0.487857,3.49038 0.390384,4.92301 l 2.364281,-0.3115 6.35829,-0.83714 -3.903556,-5.08812 -1.452457,-1.89159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1897",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.548445,253.34057 -1.679151,4.05447 c 5.177473,0.43533 12.553349,0.45015 12.553349,0.45015 0,0 -5.226401,-5.20559 -9.194799,-8.55874 l -1.679399,4.05412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1899",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.825874,261.20081 c -0.878241,1.43263 -1.082605,3.25155 -0.390384,4.92266 0.692714,1.67146 2.12284,2.81305 3.756942,3.20569 l 1.451751,-1.89194 3.904262,-5.08847 -6.35829,-0.83679 -2.364281,-0.31115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1901",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.548445,262.34875 1.679399,4.05483 c 3.968398,-3.35315 9.194799,-8.55839 9.194799,-8.55839 0,0 -7.376231,0.0145 -12.553349,0.44944 l 1.679151,4.05412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1903",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.938387,274.07508 c 0.392324,1.63372 1.53363,3.06388 3.205267,3.75673 1.671108,0.69215 3.490031,0.48789 4.923014,-0.39017 l -0.311501,-2.36467 -0.837142,-6.35811 -5.088009,3.90384 -1.891629,1.45238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1905",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.918025,268.71886 4.054474,1.67922 c 0.434975,-5.17737 0.450144,-12.55289 0.450144,-12.55289 0,0 -5.205941,5.22605 -8.558741,9.19409 l 4.054123,1.67958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1907",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.777911,277.44164 c 1.432983,0.87842 3.251555,1.08267 4.923015,0.39017 1.67146,-0.69285 2.81305,-2.12301 3.20534,-3.75673 l -1.891597,-1.45203 -5.088466,-3.90419 -0.837142,6.35811 -0.31115,2.36467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1909",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.926203,268.71886 4.054475,-1.67958 c -3.3528,-3.96839 -8.558035,-9.19409 -8.558035,-9.19409 0,0 0.0141,7.37588 0.449439,12.55289 l 4.054121,-1.67922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1911",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 55.652184,269.32916 c 1.634068,-0.39264 3.064228,-1.53352 3.75673,-3.20533 0.69215,-1.67147 0.488246,-3.49039 -0.39017,-4.92302 l -2.364317,0.31115 -6.358468,0.83714 3.904192,5.08847 1.452033,1.89159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1913",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.295959,262.3491 1.679575,-4.05447 c -5.177366,-0.43498 -12.552891,-0.44944 -12.552891,-0.44944 0,0 5.225343,5.20559 9.193741,8.55839 l 1.679575,-4.05448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1915",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.019095,254.48921 c 0.878065,-1.43263 1.082675,-3.2512 0.390174,-4.92266 -0.692857,-1.67146 -2.123017,-2.8134 -3.757085,-3.20569 l -1.452033,1.89159 -3.90384,5.08847 6.358116,0.83714 2.364668,0.31115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1917",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.296311,253.34092 -1.679927,-4.05447 c -3.968398,3.3535 -9.193741,8.55874 -9.193741,8.55874 0,0 7.375876,-0.0145 12.552891,-0.44979 l -1.679223,-4.05448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1919",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.906266,241.61529 c -0.39229,-1.63442 -1.533173,-3.06458 -3.204988,-3.75673 -1.67146,-0.6925 -3.490384,-0.48824 -4.923367,0.38982 l 0.311505,2.36432 0.837141,6.35882 5.088112,-3.90455 1.891597,-1.45168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1921",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.926557,246.97152 -4.054829,-1.67922 c -0.434621,5.17736 -0.449085,12.55289 -0.449085,12.55289 0,0 5.205235,-5.2264 8.558035,-9.19445 l -4.054121,-1.67922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1923",
    style: {
      fill: "#564118",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.545203,257.84484 c 0,2.27682 -1.845734,4.12256 -4.12256,4.12256 -2.276827,0 -4.122914,-1.84574 -4.122914,-4.12256 0,-2.27683 1.846087,-4.12292 4.122914,-4.12292 2.276826,0 4.12256,1.84609 4.12256,4.12292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower9);
export default __webpack_public_path__ + "static/media/flower-9.399c3fab9a14181755328553fc215039.svg";
export { ForwardRef as ReactComponent };